<template>
  <div class="upload-image-container">
    <!-- ElementUI上传组件核心 -->
    <el-upload
      class="upload-image"
      :action="uploadAction"
      list-type="picture-card"
      :file-list="fileList"
      :limit="limitCount"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
      :headers="uploadHeaders"
      :disabled="disabled"
      :style="uploadStyle"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
  </div>
</template>

<script>
// 引入图片预览组件API
import { api as viewerApi } from "v-viewer";
export default {
  name: "PreviewUploadImage",
  props: {
    // ✅ 必传：上传接口地址
    uploadUrl: {
      type: String,
      required: false,
    },
    // ✅ 自定义：上传按钮/上传区域的宽 【核心需求】
    uploadWidth: {
      type: [String, Number],
      default: 100,
    },
    // ✅ 自定义：上传按钮/上传区域的高 【核心需求】
    uploadHeight: {
      type: [String, Number],
      default: 100,
    },
    // ✅ 自定义：文件大小限制(M) 【核心需求】
    fileSize: {
      type: Number,
      default: 2, // 默认限制2M
    },
    // 上传请求头，如token，按需传
    headers: {
      type: Object,
      default: () => ({}),
    },
    // 限制上传文件数量，默认1张
    limitCount: {
      type: Number,
      default: 1,
    },
    // 是否禁用上传
    disabled: {
      type: Boolean,
      default: false,
    },
    // 绑定值：已上传的文件列表，支持回显，格式和el-upload一致
    value: {
      type: Array,
      default: () => [],
    },
    // 允许上传的图片格式
    acceptType: {
      type: Array,
      default: () => ["image/jpeg", "image/png", "image/gif", "image/jpg"],
    },
  },
  data() {
    return {
      uploadAction: this.uploadUrl || "",
      // 上传文件列表
      fileList: [],
      // 预览弹窗显隐
      previewDialogVisible: false,
      // 预览图片地址
      previewImageUrl: "",
      // 预览图片地址
      previewImages: [],
    };
  },
  watch: {
    // 监听父组件传的回显数据，同步到子组件文件列表
    value: {
      immediate: true,
      handler(val) {
        this.fileList = val || [];
      },
    },
  },
  computed: {
    // 拼接上传接口地址
    // uploadAction() {
    //   return this.uploadUrl;
    // },
    // 上传请求头
    uploadHeaders() {
      return this.headers;
    },
    // ✅ 动态拼接上传区域的宽高样式 【核心实现】
    uploadStyle() {
      return {
        width: `${this.uploadWidth}px`,
        height: `${this.uploadHeight}px`,
        lineHeight: `${this.uploadHeight}px`,
      };
    },
  },
  methods: {
    // ✅ 图片预览事件 【核心需求】
    handlePreview(file) {
      const previewImages = this.fileList.map((item) => item.response.data);
      // 预览图片
      viewerApi({ images: previewImages, initialViewIndex: 0 });
      console.log("预览了", file, this.fileList, previewImages);
    },
    // 删除上传文件
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.$emit("input", fileList);
      this.$emit("change", fileList);
    },
    // ✅ 文件上传前校验：格式+大小 【核心】
    beforeUpload(file) {
      // 校验图片格式
      const isImage = this.acceptType.includes(file.type);
      if (!isImage) {
        this.$message.error(
          `请上传${this.acceptType
            .map((item) => item.split("/")[1])
            .join("、")}格式的图片!`
        );
        return false;
      }
      // ✅ 校验文件大小
      const isSize = file.size / 1024 / 1024 < this.fileSize;
      if (!isSize) {
        this.$message.error(`上传图片大小不能超过 ${this.fileSize}MB!`);
        return false;
      }
      return true;
    },
    // 上传成功回调
    handleSuccess(res, file, fileList) {
      this.fileList = fileList;
      this.$emit("input", fileList);
      this.$emit("upload-success", fileList, res);
      this.$message.success("上传成功！");
    },
    // 上传失败回调
    handleError(err, file, fileList) {
      this.$emit("error", err);
      this.$message.error("上传失败，请重试！");
    },
  },
};
</script>

<style scoped>
/* 上传按钮样式优化 */
::v-deep .el-upload.el-upload--picture-card {
  width: 60px !important;
  height: 60px !important;
  line-height: 69px !important;
}
::v-deep .el-upload-list__item.is-success {
  width: 60px !important;
  height: 60px !important;
}
::v-deep .el-upload-list__item {
  width: 60px !important;
  height: 60px !important;
}
::v-deep .el-upload-list__item-actions {
  width: 60px !important;
  height: 60px !important;
}
::v-deep .el-upload-list__item-thumbnail {
  width: 60px !important;
  height: 60px !important;
}
::v-deep .el-upload-list__item-delete {
  margin-left: 5px !important;
}
.upload-image {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 60px !important;
  height: 60px !important;
}
.upload-image:hover {
  border-color: #409eff;
}
/* 预览图片样式 */
.preview-img {
  width: 100%;
  height: auto;
}
</style>
